"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TopAreaNavigationMenu = require("./TopAreaNavigationMenu");
Object.keys(_TopAreaNavigationMenu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopAreaNavigationMenu[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopAreaNavigationMenu[key];
    }
  });
});
